import styled from 'styled-components';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RangeLabel = styled.label`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const Hint = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;
